import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {IDocument} from "../../interfaces/document.definition";
import {JP} from "../../helpers/jp";
import * as _ from "underscore";
import {WatchService} from "../../services/watch.service";
import {Subject} from "rxjs/Subject";
import {BusService} from "../../services/bus.service";
import {Observable} from "rxjs/Observable";
import {Http, Response} from "@angular/http";
import {ErrorService} from "../../services/error.service";
import {AnimationsService, IAnimationInfo} from "../../services/animations.service";
import {PreloaderService} from "../../services/preloader.service";

@Component({
  selector: 'nv-load-img-btn',
  templateUrl: './nv-load-img-btn.component.html',
  styles: []
})
export class NvLoadImgBtnComponent implements OnInit, OnDestroy {
  private _document:IDocument;
  private _pointer: string;
  private imageInfo: IAnimationInfo;
  private unsubscribe: Subject<void> = new Subject<void>();

  @Input()
  set document(v:IDocument) {
    this._document = v;
  }

  get document():IDocument {
    return this._document;
  }

  @Input()
  set pointer(v: string) {
    this._pointer = v;
  }

  get pointer() {
    return this._pointer;
  }



  constructor(private modalService:ModalService,
              private busService:BusService,
              private animationsService: AnimationsService,
              private errorService:ErrorService,
              private preloaderService:PreloaderService) {
    this.busService.onDocumentSaved
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.onDocSaved());
  }


  onClick() {
    this.modalService.showImageUpload(this.document, this.pointer);
  }


  ngOnInit() {
    this.loadImageInfo();
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getModel() {
    if (_.isUndefined(this.document) || _.isUndefined(this.pointer)){
      return;
    }
    return JP.get(this.document, this.pointer);
  }

  private loadImageInfo() {
    this.animationsService
      .loadInfo("image", this._document.id.toString(), this._document._type, this._pointer)
      .subscribe(
        a => {
          this.imageInfo = a;
        });
  }

  private onDocSaved() {
    console.log("doc saved");
    this.preloaderService.show();
    this.animationsService
      .clearContent("image","" + this._document.id, this._document._type, this._pointer)
      .subscribe(() => {
        this.animationsService.updateContent("image","" + this._document.id, this._document._type, this._pointer, [JP.get(this._document, this._pointer)])
          .subscribe((result) => {
            if (result.status == 200){
              this.preloaderService.hide();
            }
            else {
              this.errorService.handleError(new Error(`Upload error: ${result}`));
            }
          });
      });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-load-img-btn/nv-load-img-btn.component.ts